








import {Vue} from "vue-property-decorator";
import {Component} from "vue-property-decorator";

@Component({})
export default class Unauthorized extends Vue {
}

